"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
var owa_strings_1 = require("owa-strings");
var owa_bulk_action_store_1 = require("owa-bulk-action-store");
var bulkTriageConstants_1 = require("owa-mail-store/lib/utils/bulkTriageConstants");
var owa_trace_1 = require("owa-trace");
/**
 * Gets the confirm text for delete all dialog.
 * @param actionSource Action that initiated the delete all action
 * @param listViewType The view type of the folder being deleted
 * @param totalCount The total count of items in folder
 * @returns The text shown in delete all confirmation dialog
 */
function getDeleteAllConfirmText(actionSource, listViewType, totalCount, folder) {
    var isMessageView = listViewType === 1 /* Message */;
    /**
     * Special-case "ContextFolder" because the TotalCount received from the
     * Folder object is always message count.
     */
    var useItemStrings = actionSource === 'ContextFolder' || isMessageView;
    if (totalCount == 0) {
        owa_trace_1.trace.warn('getDeleteAllConfirmText should not be called.');
        return '';
    }
    else {
        owa_bulk_action_store_1.lazyOnBulkActionSubmitted.importAndExecute(folder, totalCount);
        if (totalCount == 1) {
            return owa_mail_strings_1.default.deleteItem;
        }
        else if (totalCount < bulkTriageConstants_1.MAX_LABEL_ITEM_COUNT) {
            return useItemStrings
                ? owa_strings_1.format(owa_mail_strings_1.default.deleteNumberOfItems, totalCount)
                : owa_strings_1.format(owa_mail_strings_1.default.deleteNumberOfConversations, totalCount);
        }
        else {
            return useItemStrings
                ? owa_strings_1.format(owa_mail_strings_1.default.deleteNumberOfItems, '10000+')
                : owa_strings_1.format(owa_mail_strings_1.default.deleteNumberOfConversations, '10000+');
        }
    }
}
exports.default = getDeleteAllConfirmText;
//# sourceMappingURL=getDeleteAllConfirmText.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/helpers/getDeleteAllConfirmText.js
// module id = 5647
// module chunks = 62